import { render } from "./dataStatistics.vue?vue&type=template&id=b3f15c62&scoped=true&ts=true"
import script from "./dataStatistics.vue?vue&type=script&lang=ts"
export * from "./dataStatistics.vue?vue&type=script&lang=ts"

import "./dataStatistics.vue?vue&type=style&index=0&id=b3f15c62&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f15c62"]])

export default __exports__